import React, { useState, useEffect } from 'react';
import Link from './LocalizedLink';

import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const consent = localStorage.getItem('faccioapp_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = (analytics) => {
    localStorage.setItem('faccioapp_cookie_consent', JSON.stringify({
      necessary: true,
      analytics,
      timestamp: new Date().toISOString()
    }));
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-[9998] p-4"
      data-testid="cookie-banner"
    >
      <div className="max-w-2xl mx-auto card-elevated p-6">
        <div className="flex items-start justify-between gap-4 mb-4">
          <p className="text-sm text-[var(--color-text)]">
            {t('cookie.text_prefix')}{' '}
            <Link to="/privacy" className="text-[var(--color-primary)] hover:underline">
              {t('cookie.privacy_link')}
            </Link>
          </p>
          <button 
            onClick={() => handleAccept(false)}
            className="text-[var(--color-text-muted)] hover:text-[var(--color-text)]"
            aria-label={t('cookie.close')}
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="flex gap-3">
          <Button
            onClick={() => handleAccept(true)}
            className="btn-accent flex-1"
            data-testid="cookie-accept-all"
          >
            {t('cookie.accept')}
          </Button>
          <Button
            onClick={() => handleAccept(false)}
            variant="outline"
            className="flex-1 rounded-full"
            data-testid="cookie-accept-necessary"
          >
            {t('cookie.necessary')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
